/* eslint-disable no-unused-vars,jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import {
  sendForm,
  changeFieldUserName,
  changeFieldEmail,
  changeFieldPhoneNumber,
  selectFieldUsername,
  selectFieldEmail,
  selectFieldPhoneNumber,
  selectRequestState,
  loadFormData
} from 'mt-react-common/modules/users/common/reducers/forms/profileForm';

import OpacityPreLoader from '../../Common/PreLoaders/OpacityPreLoader';

const profileFormRN = 'usersModule.forms.profileForm';

// eslint-disable-next-line react/prefer-stateless-function
class UserProfileForm extends Component {
  componentDidMount() {
    this.props.loadFormData();
  }

  render() {
    const hasError = fieldErrors => fieldErrors.length > 0;
    const errorDesc = fieldErrors => {
      if (fieldErrors.length > 0) {
        return (
          <React.Fragment>
            <small className="help-block">{fieldErrors[0].message}</small>
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <div className="panel panel-default panel-heading_padding-large panel-body_bg-sub panel-footer_padding-large">
        <div className="panel-heading text-center">
          <h1 className="panel-title">
            <i className="fa fa-user" /> {t('Данные профиля')}
          </h1>
        </div>
        <form
          className="pos-rel ng-untouched ng-pristine ng-valid"
          noValidate=""
        >
          <div
            aria-labelledby="myModalLabel"
            className="modal fade"
            id="modalConfirmSaveProfile"
            role="dialog"
            tabIndex="-1"
          >
            <div className="modal-dialog modal-gray modal-sm">
              <div className="modal-content">
                <div className="modal-header text-center">
                  <a
                    aria-label="Close"
                    className="close close-black"
                    data-dismiss="modal"
                    href=""
                  />
                  <i className="fa fa-exclamation-triangle modal-icon" />
                  <h4 className="modal-title">
                    <strong>{t('Подтверждение')}</strong>
                  </h4>
                </div>
                <div className="modal-body text-center">
                  {t('Вы уверены, что хотите сохранить изменения?')}
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-muted"
                    data-dismiss="modal"
                    type="button"
                  >
                    {t('Отмена')}
                  </button>
                  <button
                    className="btn btn-primary"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.props.sendForm()}
                  >
                    {t('Сохранить')}
                  </button>
                </div>
              </div>
            </div>
          </div>
          {this.props.requestStatusData.hasInProgress ? (
            <OpacityPreLoader />
          ) : null}
          <div className="panel-body">
            <div
              className={`form-group ${
                hasError(this.props.fieldUsername.errors) ? 'has-error' : ''
              }`}
            >
              <label className="control-label" htmlFor="username">
                {t('Имя пользователя')}
              </label>
              <input
                className="form-control ng-untouched ng-pristine ng-valid"
                id="username"
                name="username"
                pattern="^[a-zA-Z0-9_.+-]+$"
                value={this.props.fieldUsername.value || ''}
                onChange={e => {
                  this.props.changeFieldUserName(e.target.value);
                }}
                placeholder={t('Имя пользователя')}
                required=""
                type="text"
              />
              {errorDesc(this.props.fieldUsername.errors)}
            </div>
            <div
              className={`form-group ${
                hasError(this.props.fieldEmail.errors) ? 'has-error' : ''
              }`}
            >
              <label className="control-label" htmlFor="email">
                {t('Электронная почта')}
              </label>
              <input
                className="form-control ng-untouched ng-pristine ng-valid"
                id="email"
                name="email"
                pattern="^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$"
                value={this.props.fieldEmail.value || ''}
                onChange={e => {
                  this.props.changeFieldEmail(e.target.value);
                }}
                placeholder="E-mail"
                required=""
                type="email"
              />
              {errorDesc(this.props.fieldEmail.errors)}
            </div>
            <div
              className={`form-group m-b-0 ${
                hasError(this.props.fieldPhoneNumber.errors) ? 'has-error' : ''
              }`}
            >
              <label className="control-label" htmlFor="tel">
                {t('Телефон')}
              </label>
              <input
                className="form-control ng-untouched ng-pristine ng-valid"
                id="tel"
                name="tel"
                pattern="^[+]+[0-9]+$"
                value={this.props.fieldPhoneNumber.value || ''}
                onChange={e => {
                  this.props.changeFieldPhoneNumber(e.target.value);
                }}
                placeholder={t('Телефон')}
                type="tel"
              />
              <small className="help-block m-b-0" id="helpBlock">
                {t('Номер телефона должен быть введен в формате {format}', {
                  format: '+7xxxxxxxxx'
                })}
              </small>
              {errorDesc(this.props.fieldPhoneNumber.errors)}
            </div>
          </div>
          <div className="panel-footer">
            <div className="btn-toolbar">
              <a
                className="btn btn-primary"
                data-toggle="modal"
                href="#modalConfirmSaveProfile"
              >
                {t('Сохранить')}
              </a>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

UserProfileForm.propTypes = {
  loadFormData: PropTypes.func.isRequired,
  fieldUsername: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.arrayOf(PropTypes.shape).isRequired
  }).isRequired,
  fieldEmail: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.arrayOf(PropTypes.shape).isRequired
  }).isRequired,
  fieldPhoneNumber: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.arrayOf(PropTypes.shape).isRequired
  }).isRequired,

  requestStatusData: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired
  }).isRequired,

  changeFieldUserName: PropTypes.func.isRequired,
  changeFieldEmail: PropTypes.func.isRequired,
  changeFieldPhoneNumber: PropTypes.func.isRequired,
  sendForm: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  fieldUsername: selectFieldUsername(state, profileFormRN),
  fieldEmail: selectFieldEmail(state, profileFormRN),
  fieldPhoneNumber: selectFieldPhoneNumber(state, profileFormRN),

  requestStatusData: selectRequestState(state, profileFormRN)
});

const mapDispatchToProps = (dispatch, props) => ({
  loadFormData: () => dispatch(loadFormData(profileFormRN, props.userId)),
  changeFieldUserName: value =>
    dispatch(changeFieldUserName(profileFormRN, value)),
  changeFieldEmail: value => dispatch(changeFieldEmail(profileFormRN, value)),
  changeFieldPhoneNumber: value =>
    dispatch(changeFieldPhoneNumber(profileFormRN, value)),
  sendForm: () => dispatch(sendForm(profileFormRN))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserProfileForm)
);



// WEBPACK FOOTER //
// ./src/components/UserAccount/UserProfileForm/UserProfileForm.js